export default __webpack_public_path__ + "static/media/UNIPDR_125.94cafb81.pdf";